import { Waypoint } from "vue-waypoint";

export default {
  name: "VenueTip",
  props: {
    data: Object,
  },
  components: {
    Waypoint,
  },
  created() {},
};
